import { render, staticRenderFns } from "./OrdersHistory.vue?vue&type=template&id=2d46e768&scoped=true"
import script from "./OrdersHistory.vue?vue&type=script&lang=js"
export * from "./OrdersHistory.vue?vue&type=script&lang=js"
import style0 from "./OrdersHistory.vue?vue&type=style&index=0&id=2d46e768&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d46e768",
  null
  
)

export default component.exports